import axios from "axios";
import { LEADS_ENDPOINTS, API_BASE_URL } from "../constants/apis";
import tokenRefreshService from "./tokenRefresh";

// Leads service for fetching leads
class LeadsService {
    constructor() {
        this.baseURL = API_BASE_URL;
    }

    // Get all leads with filters
    async getLeads(filters = {}) {
        try {
            const token = await tokenRefreshService.getValidToken();
            const headers = {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            };

            // Build query parameters
            const params = new URLSearchParams();
            if (filters.timezone) params.append('timezone', filters.timezone);
            if (filters.from_date) params.append('from_date', filters.from_date);
            if (filters.to_date) params.append('to_date', filters.to_date);
            if (filters.field_name) params.append('field_name', filters.field_name);
            if (filters.field_value) params.append('field_value', filters.field_value);

            const queryString = params.toString();
            const url = `${this.baseURL}${LEADS_ENDPOINTS.LEADS_LIST}${queryString ? `?${queryString}` : ''}`;

            const response = await axios.get(url, { headers });
            return response.data;
        } catch (error) {
            console.error('Error fetching leads:', error);
            throw error;
        }
    }
}

// Create singleton instance
const leadsService = new LeadsService();

export default leadsService;

